import React from "react";
import styles from "./LeftTabContent.module.scss";
import { useTranslation } from "react-i18next";

interface ContentItem {
  id: string;
  labelKey: string;
}

const CONTENT_ITEMS: ContentItem[] = [
  { id: "section-6", labelKey: "agrContentSix" },
  { id: "section-7", labelKey: "agrContentSeven" },
  { id: "section-8", labelKey: "agrContentEight" },
  { id: "section-9", labelKey: "agrContentNine" },
  { id: "section-10", labelKey: "agrContentTen" },
  { id: "section-11", labelKey: "agrContentEleven" },
  { id: "section-12", labelKey: "agrContentTwelve" },
  { id: "section-13", labelKey: "agrContentThirteen" },
  { id: "section-14", labelKey: "agrContentFourteen" },
  { id: "section-15", labelKey: "agrContentFifteen" },
  { id: "section-16", labelKey: "agrContentSixteen" },
];

const SCROLL_OFFSET = 50;

const RightTabContent = () => {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.tabContentWrapper}>
        <h2 className={styles.tabTitle}>{t("privacyPolicy")}</h2>
        <div className={styles.listWrapper}>
          <h3 className={styles.listTitle}>{t("agrContentTitle")}</h3>
          <ol className={styles.list}>
            {CONTENT_ITEMS.map((item) => (
              <li key={item.id}>
                <a href={`#${item.id}`} onClick={scrollToSection(item.id)}>
                  {t(item.labelKey)}
                </a>
              </li>
            ))}
          </ol>
        </div>

        <div className={styles.sectionWrapper}>
          <div className={styles.text}>{t("privacy1text")}</div>
          <div id="section-6" className={styles.subtitle}>{t("privacy1title")}</div>
          <div className={styles.text}>{t("privacy1.1")}</div>
          <div className={styles.text}>{t("privacy1.2")} <a href="mailto:info@hiviewer.com">info@hiviewer.com</a></div>
          <div id="section-7" className={styles.subtitle}>{t("privacy2title")}</div>
          <div className={styles.text}>{t("privacy2.1")}</div>
          <ul className={styles.list_text}>
            <li className={styles.text}><strong>{t("privacy2.2")}</strong> {t("privacy2.3")}</li>
            <li className={styles.text}><strong>{t("privacy2.4")}</strong> {t("privacy2.5")}</li>
            <li className={styles.text}><strong>{t("privacy2.6")}</strong> {t("privacy2.7")}</li>
            <li className={styles.text}><strong>{t("privacy2.8")}</strong> {t("privacy2.9")}</li>
            <li className={styles.text}><strong>{t("privacy2.10")}</strong> {t("privacy2.11")}</li>
            <li className={styles.text}><strong>{t("privacy2.12")}</strong> {t("privacy2.13")}</li>
            <li className={styles.text}><strong>{t("privacy2.14")}</strong> {t("privacy2.15")}</li>
          </ul>
          <div className={styles.text}>{t("privacy2.16")}</div>

          <div id="section-8" className={styles.subtitle}>{t("privacy3title")}</div>
          <div className={styles.text}>{t("privacy3.1")}</div>

          <ul className={styles.list_text}>
            <li className={styles.text}>{t("privacy3.2")}</li>
            <li className={styles.text}>{t("privacy3.3")}</li>
            <li className={styles.text}>{t("privacy3.4")}</li>
            <li className={styles.text}>{t("privacy3.5")};</li>
            <li className={styles.text}>{t("privacy3.6")}</li>
            <li className={styles.text}>{t("privacy3.7")}</li>
            <li className={styles.text}>{t("privacy3.8")}</li>
            <li className={styles.text}>{t("privacy3.9")}</li>
            <li className={styles.text}>{t("privacy3.10")}</li>
            <li className={styles.text}>{t("privacy3.11")}</li>
          </ul>

          <div className={styles.text}>{t("privacy3.12")}</div>

          <div>{t("privacy3.13")}</div>

          <div id="section-9" className={styles.subtitle}>{t("privacy4title")}</div>
          <div className={styles.text}>{t("privacy4.1")}</div>

          <ul className={styles.list_text}>
            <li className={styles.text}><strong>{t("privacy4.2")}</strong> {t("privacy4.3")}</li>
            <li className={styles.text}><strong>{t("privacy4.4")}</strong> {t("privacy4.5")}</li>
            <li className={styles.text}><strong>{t("privacy4.6")}</strong> {t("privacy4.7")}</li>
            <li className={styles.text}><strong>{t("privacy4.8")}</strong> {t("privacy4.9")}</li>
            <li className={styles.text}><strong>{t("privacy4.10")}</strong> {t("privacy4.11")}</li>
            <li className={styles.text}><strong>{t("privacy4.12")}</strong> {t("privacy4.13")}</li>
            <li className={styles.text}><strong>{t("privacy4.14")}</strong> {t("privacy4.15")}</li>
          </ul>
          <div className={styles.text}>{t("privacy4.16")} <strong>{t("privacy4.17")}</strong> {t("privacy4.18")}</div>

          <div id="section-10" className={styles.subtitle}>{t("privacy5title")}</div>
          <div className={styles.text}>{t("privacy5.1")}</div>

          <div id="section-11" className={styles.subtitle}>{t("privacy6title")}</div>
          <div className={styles.text}>{t("privacy6.1")}</div>

          <ul className={styles.list_text}>
            <li className={styles.text}>{t("privacy6.2")}</li>
            <li className={styles.text}>{t("privacy6.3")}</li>
            <li className={styles.text}>{t("privacy6.4")}</li>
            <li className={styles.text}>{t("privacy6.5")}</li>
            <li className={styles.text}>{t("privacy6.6")}</li>
            <li className={styles.text}>{t("privacy6.7")}</li>
            <li className={styles.text}>{t("privacy6.8")}</li>
          </ul>

          <div className={styles.text}>{t("privacy6.9")}</div>

          <div id="section-12" className={styles.subtitle}>{t("privacy7title")}</div>
          <div className={styles.text}>{t("privacy7.1")}</div>

          <ul className={styles.list_text}>
            <li className={styles.text}>{t("privacy7.2")}</li>
            <li className={styles.text}>{t("privacy7.3")}</li>
            <li className={styles.text}>{t("privacy7.4")}</li>
            <li className={styles.text}>{t("privacy7.5")}</li>
            <li className={styles.text}>{t("privacy7.6")}</li>
            <li className={styles.text}>{t("privacy7.7")}</li>
            <li className={styles.text}>{t("privacy7.8")}</li>
            <li className={styles.text}>{t("privacy7.9")}</li>
          </ul>

          <div className={styles.text}>{t("privacy7.10")} <strong>{t("privacy7.11")}</strong> {t("privacy7.12")} <a href="mailto:info@hiviewer.com">info@hiviewer.com</a>. {t("privacy7.13")}</div>

          <div className={styles.text}>{t("privacy7.14")}</div>

          <div id="section-13" className={styles.subtitle}>{t("privacy8title")}</div>
          <div className={styles.text}>{t("privacy8.1")}</div>

          <div id="section-14" className={styles.subtitle}>{t("privacy9title")}</div>
          <div className={styles.text}>{t("privacy9.1")}</div>

          <div id="section-15" className={styles.subtitle}>{t("privacy10title")}</div>
          <div className={styles.text}>{t("privacy10.1")}</div>

          <div id="section-16" className={styles.subtitle}>{t("privacy11title")}</div>
          <div className={styles.text}>{t("privacy11.1")}</div>

          <div className={styles.text}>
            <div>{t("privacy11.2")}</div>
            <div>{t("privacy11.3")}</div>
            <div>{t("privacy11.5")}</div>
            <div>{t("privacy11.4")} <a href="mailto:info@hiviewer.com">info@hiviewer.com</a></div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RightTabContent;
